<template>
  <BaseFilters
    :bem="bemBlock"
    :disabled="loading"
    :filter-display-name="filterDisplayName"
    :options="options"
    :selected="refinementSelectedOptions"
    :show="options && options.length > 1"
    :css-custom-props="cssCustomProps"
    @select="selectFilter"
    @deselect="deselectFilter"
  />
</template>

<script>
import bemClassesMixin from '../mixins/bemClassesMixin';
import BaseFilters from './BaseFilters.vue';

export default {
  name: 'BaseFiltersSize',

  components: {
    BaseFilters,
  },

  mixins: [bemClassesMixin],

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    refinement: {
      type: Object,
      default: () => ({}),
    },
    selected: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    selectedOptions: null,
    MAX_FILTERS_PER_COLUMN: 8,
  }),

  computed: {
    cssCustomProps() {
      const optionsLength = this.options?.length;
      let textOptionsLength = 0;
      let numericOptionsLength = 0;
      for (let i = 0; i < optionsLength; i++) {
        const size = this.options[i];
        if (this.isNumericSize(size)) {
          numericOptionsLength += 1;
        } else {
          textOptionsLength += 1;
        }
      }
      const gridRows = Math.min(
        Math.max(textOptionsLength, numericOptionsLength),
        this.MAX_FILTERS_PER_COLUMN
      );
      return { '--grid-rows': gridRows };
    },
    filterDisplayName() {
      return this.$msg('filters.size.text', 'filters');
    },
    options() {
      const options = this.refinement?.values;

      const firstNumericOptionIndex = options?.findIndex(this.isNumericSize);
      if (options && options[firstNumericOptionIndex]) {
        options[firstNumericOptionIndex].isFirstNumber = true;
      }

      return options;
    },
    refinementAttributeID() {
      return this.refinement?.values?.[0]?.id;
    },
    refinementSelectedOptions() {
      return this.selected?.filter(
        (selectedOption) => selectedOption.id === this.refinementAttributeID
      );
    },
  },

  methods: {
    isNumericSize(size) {
      return !Number.isNaN(parseInt(size.value, 10));
    },
    selectFilter(option) {
      this.$emit('select', option);
    },
    deselectFilter(option) {
      this.$emit('deselect', option);
    },
  },
};
</script>
